/**
 * 組出要傳給現場清點同工的邀請訊息。
 *
 * 訊息會貼進 LINE 或簡訊，所以刻意用純文字、短行、編號步驟，
 * 不要 Markdown 也不要表格——那些在通訊軟體裡只會變成雜訊。
 */

export const INVENTORY_ACCESS_ROUTE = '#inventory-access';

export interface InventoryInviteInput {
  code: string;
  eventLabel?: string;
  /** 網站根網址，例如 https://apply.tjcmed.org */
  origin: string;
  /** 通行碼有效時數，用來提醒同工當日使用。 */
  validHours: number;
}

export const buildInventoryAccessUrl = (origin: string): string =>
  `${origin.replace(/\/+$/, '')}/${INVENTORY_ACCESS_ROUTE}`;

export const buildInventoryInviteMessage = ({
  code,
  eventLabel,
  origin,
  validHours,
}: InventoryInviteInput): string => {
  const heading = eventLabel
    ? `【醫宣物資清點】${eventLabel}`
    : '【醫宣物資清點】';

  return [
    heading,
    '',
    `1. 開啟連結：${buildInventoryAccessUrl(origin)}`,
    '2. 填寫您的姓名（用來標記清點紀錄）',
    `3. 輸入通行碼：${code}`,
    '',
    `不需要 Google 帳號。通行碼 ${validHours} 小時後自動失效，請於清點當日使用。`,
  ].join('\n');
};
